import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "27px",
	height: "18px",
	viewBox: "0 0 27 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "9B310E12-E4CD-44EA-9108-9A85168FA780"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Gydytoj\\u0173-s\\u0105ra\\u0161as",
			transform: "translate(-165.000000, -198.000000)",
			fill: "#000000",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M183.849591,198.849591 L190.788,205.788 L190.826087,205.788225 L190.826,205.826 L191.849591,206.849591 L190.826,207.872 L190.826087,208.050967 L190.648,208.05 L183.548772,215.150409 L181.948772,213.550409 L187.447,208.05 L165,208.050967 L165,205.788225 L187.467,205.788 L182.189427,200.509754 L183.849591,198.849591 Z",
				id: "back-copy",
				transform: "translate(178.500000, 207.000000) scale(-1, 1) translate(-178.500000, -207.000000) "
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgBackArrow);
export default ForwardRef;
